import React from "react";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import { formatDateReadable } from "../../utilities/helpers";
import { getInitials } from "../../utilities/helpers";
import ShiftPoolBidCard from "./ShiftPoolBidCard";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Drawer } from "@mui/material";
import ButtonFilled from "../../shared/helpers/ButtonFilled";
import ButtonGrayed from "../../shared/helpers/ButtonGrayed";
import ButtonDelete from "../../shared/helpers/ButtonDelete";
import DrawerHeader from "../../shared/helpers/DrawerHeader";
import GroupIcon from "@mui/icons-material/Group";
import Tooltip from "@mui/material/Tooltip";
import {
  CalendarToday,
  Description,
  ChatBubbleOutline,
  Send,
  Edit,
  AccessTime,
  WorkOutline,
  FreeBreakfastOutlined,
  PlaceOutlined,
} from "@mui/icons-material";
import ModalInfoCard from "../../shared/helpers/ModalInfoCard";
import ButtonFilledCancel from "../../shared/helpers/ButtonFilledCancel";

export default function ShiftPoolRequestsTableRow(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    border: "2px solid #E2E8F0",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [selectedBid, setSelectedBid] = React.useState(null);

  const handleBidSelect = (bidName) => {
    setSelectedBid(bidName);
  };

  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  function handleDeny() {
    props.manager_reject_shift_drop(props.id);
    handleClose();
    setDrawerOpen(false);
  }

  function handleApprove() {
    props.manager_approve_shift_pickup(selectedBid, "approved");
    handleClose();
    setDrawerOpen(false);
  }

  function handleOpenShift() {
    props.manager_accept_shift_drop(props.id, "open_shift");
    handleClose();
    setDrawerOpen(false);
  }

  function handleDeleteShift() {
    props.manager_accept_shift_drop(props.id, "delete");
    handleClose();
    setDrawerOpen(false);
  }

  return (
    <>
      <tr
        className="hover:bg-slate-50 cursor-pointer transition-colors"
        onClick={toggleDrawer(true)}
      >
        <td className="whitespace-nowrap py-3.5 pl-6 pr-3 text-sm">
          <div className="flex items-center space-x-2">
            <div
              className={`${
                props.status === "PENDING_DROP"
                  ? "text-rose-600"
                  : "text-emerald-600"
              }`}
            >
              {props.status === "PENDING_DROP" ? (
                <RemoveCircleIcon sx={{ fontSize: 14 }} />
              ) : (
                <AddCircleIcon sx={{ fontSize: 14 }} />
              )}
            </div>
            <div
              className={`font-semibold text-sm ${
                props.status === "PENDING_DROP"
                  ? "text-rose-700"
                  : "text-emerald-700"
              }`}
            >
              {props.status === "PENDING_DROP" ? "Drop request by" : "Open shift"}
            </div>
          </div>
          {props.status === "PENDING_DROP" && (
            <div className="flex items-center space-x-1.5 mt-0.5">
              <div className="w-5 h-5 bg-slate-200 rounded-full flex items-center justify-center">
                <p className="text-slate-600 text-[9px]">
                  {getInitials(props.name)}
                </p>
              </div>
              <p className="text-slate-500 text-xs">{props.name}</p>
            </div>
          )}
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm">
          <div className="font-semibold text-slate-900">{formatDateReadable(props.date)}</div>
          <div className="text-slate-500 text-xs mt-0.5">{props.shift}</div>
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm text-slate-500">
          {props.station
            ? props.station
            : props.role
            ? props.role
            : props.roleType}
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm">
          {(props.note || props.employeeDropNote) && (
            <Tooltip
              title={
                <>
                  {props.note && <div>Shift note: {props.note}</div>}
                  {props.employeeDropNote && (
                    <div>Employee drop note: {props.employeeDropNote}</div>
                  )}
                </>
              }
            >
              <span className="text-violet-600 cursor-pointer">
                <ChatBubbleOutline sx={{ fontSize: 16 }} />
              </span>
            </Tooltip>
          )}
        </td>
        <td className="whitespace-nowrap pl-3 pr-6 py-3.5 text-sm text-slate-500">
          {props.bids.length > 0 ? (
            <div className="flex items-center justify-end">
              <AvatarGroup max={4}>
                {props.bids.map((bid, index) => (
                  <Avatar
                    key={index}
                    sx={{
                      width: 30,
                      height: 30,
                      fontSize: 11,
                      backgroundColor: "#e2e8f0",
                      color: "#475569",
                    }}
                  >
                    {bid.employee_pickup.first_name[0]}
                    {bid.employee_pickup.last_name[0]}
                  </Avatar>
                ))}
              </AvatarGroup>
            </div>
          ) : (
            <div className="text-slate-400 text-xs text-right">No bids yet</div>
          )}
        </td>
      </tr>
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer(false)}>
        <div className="w-[450px] h-full bg-white relative">
          <div className="max-h-screen overflow-auto">
            <DrawerHeader
              title="Shift Pickup Request"
              onClose={toggleDrawer(false)}
            />
            <div className="mt-8 px-6">
              {props.status === "PENDING_DROP" ? (
                <div className="w-full bg-rose-50 rounded-xl border border-rose-100 p-3 flex flex-row items-center space-x-1.5">
                  <div className="text-rose-600">
                    <RemoveCircleIcon />
                  </div>
                  <p className="text-rose-800 text-lg">Drop request by</p>
                  <div className="flex flex-row items-center space-x-1.5 pl-2">
                    <p className="text-slate-500 text-lg">{props.name}</p>
                  </div>
                </div>
              ) : (
                <div className="w-full bg-emerald-50 rounded-xl border border-emerald-100 p-3 flex flex-row items-center space-x-1.5">
                  <div className="text-emerald-600">
                    <AddCircleIcon />
                  </div>
                  <p className="text-emerald-800 text-lg">Open shift</p>
                </div>
              )}

              <div className="w-full mt-6">
                <div className="mb-4 flex items-center space-x-4">
                  <div className="flex-1">
                    <ModalInfoCard
                      icon={CalendarToday}
                      title="Date"
                      value={formatDateReadable(props.date)}
                    />
                  </div>
                  <div className="flex-1">
                    <ModalInfoCard
                      icon={AccessTime}
                      title="Time"
                      value={props.shift}
                    />
                  </div>
                </div>

                <div className="mb-4 flex items-center space-x-4">
                  <div className="flex-1">
                    <ModalInfoCard
                      icon={FreeBreakfastOutlined}
                      title="Break"
                      value={props.breakFormatted}
                    />
                  </div>
                  <div className="flex-1">
                    <ModalInfoCard
                      icon={WorkOutline}
                      title="Role"
                      value={
                        props.station
                          ? props.station
                          : props.role
                          ? props.role
                          : props.roleType
                      }
                    />
                  </div>
                </div>

                {props.note && (
                  <div className="mb-4">
                    <ModalInfoCard
                      icon={ChatBubbleOutline}
                      title="Shift Note"
                      value={props.note}
                    />
                  </div>
                )}

                {props.employeeDropNote && (
                  <div className="mb-4">
                    <ModalInfoCard
                      icon={ChatBubbleOutline}
                      title="Employee Drop Note"
                      value={props.employeeDropNote}
                    />
                  </div>
                )}

                {props.location && (
                  <div className="mb-4">
                    <ModalInfoCard
                      icon={PlaceOutlined}
                      title="Location"
                      value={props.location}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="px-6">
              <div className="bg-gray-50 border border-gray-200 rounded-xl px-4 py-3">
                <div className="flex items-center space-x-2 mb-3">
                  <div className="text-slate-600">
                    <GroupIcon style={{ fontSize: 18 }} />
                  </div>
                  <p className="text-slate-700 font-medium text-sm">
                    Pickup Requests ({props.bids?.length || 0})
                  </p>
                </div>

                {props.bids?.length > 0 ? (
                  <div className="space-y-3">
                    {props.bids?.map((bid, i) => (
                      <ShiftPoolBidCard
                        key={i}
                        isSelected={selectedBid === bid.uuid}
                        info={bid}
                        hours={props.hours}
                        handleBidSelect={() => handleBidSelect(bid.uuid)}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="bg-white rounded-xl p-8 flex flex-col items-center justify-center">
                    <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center mb-3">
                      <InfoOutlinedIcon sx={{ fontSize: 20, color: "#94a3b8" }} />
                    </div>
                    <p className="text-sm text-slate-400 text-center">
                      No pickup requests yet
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="w-full h-[320px]"></div>
            <div className="w-full absolute bottom-0 bg-white border-t border-slate-300 px-6">
              <div className="pb-4">
                {props.status === "PENDING_DROP" && (
                  <div className="mt-4">
                    <ButtonFilledCancel
                      text="Deny drop"
                      onClick={() => handleDeny()}
                    />
                  </div>
                )}
                {selectedBid ? (
                  <div className="w-full mt-4">
                    <ButtonFilled
                      text="Assign to selected"
                      onClick={() => handleApprove()}
                    />
                  </div>
                ) : props.bids.length === 0 &&
                  props.status === "PENDING_DROP" ? (
                  <div className="w-full mt-2 space-y-2">
                    <ButtonFilled
                      text="Accept drop & turn to open shift"
                      onClick={() => handleOpenShift()}
                    />
                    <ButtonDelete
                      text="Accept drop & delete shift"
                      onClick={() => handleDeleteShift()}
                    />
                  </div>
                ) : (
                  <div className="w-full mt-4">
                    <ButtonGrayed text="Assign to selected" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
}
